import { render } from "./TotalLtlItem.vue?vue&type=template&id=68546108&scoped=true"
import script from "./TotalLtlItem.vue?vue&type=script&lang=js"
export * from "./TotalLtlItem.vue?vue&type=script&lang=js"

import "./TotalLtlItem.vue?vue&type=style&index=0&id=68546108&lang=scss&scoped=true"

import exportComponent from "/Applications/dev/FLEXX_FREIGHT/flexx-freight-stats/website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68546108"]])

export default __exports__